/******************************************************************************/
/* Helpers
/* https://github.com/ImpressionDigital/_snippets
/******************************************************************************/

/**
* Animates to hash links when clicked
*/
function fnScrollToID( oEvent ) {

	oEvent.preventDefault();

	$( 'html, body' ).animate({
        scrollTop: $( $( oEvent.currentTarget ).attr( 'href' ) ).offset().top - 120
    }, 1500, 'easeOutCubic' );

}




// END OF DOCUMENT
